<syslink-grid
  #grid
  [gridName]="storageKey"
  [canView]="canView"
  [canSearch]="canSearch"
  [canRefresh]="canRefresh"
  [canAdd]="canAdd"
  [canSort]="canSort"
  [canDelete]="canDelete"
  [canFilter]="canFilter"
  [canExport]="canExport"
  [canDblClck]="canDblClck"
  [service]="userGroupsService"
  [columns]="columns"
  [filter]="filter"
  [canUpdate]="false"
  [storageKey]="storageKey"
  (add)="onAddButtonClicked()"
  (beforeDelete)="onDeleteClicked($event)"
  (doubleClick)="onDoubleClicked($event)"
></syslink-grid>
